import React, { useState } from "react";

export default function ArticleFilters({
    categories,
    activeCategory,
    activeTopic,
    onSelectCategory,
    onSelectTopic,
    onClear,
    mobileOpen,
    onToggleMobile,
}) {
    const [expandedSlug, setExpandedSlug] = useState(activeCategory || null);

    const toggleCategory = (slug) => {
        setExpandedSlug((current) => (current === slug ? null : slug));
    };

    const filterPanel = (
        <>
            <div className="lh-filters-head">
                <h2>Filters</h2>
                {(activeCategory || activeTopic) && (
                    <button type="button" className="lh-clear-btn" onClick={onClear}>
                        Clear filters
                    </button>
                )}
            </div>
            <div className="lh-filter-groups">
                {categories.map((category) => {
                    const isOpen = expandedSlug === category.slug;
                    const topics = category.topics || [];
                    return (
                        <div key={category.slug} className="lh-filter-group">
                            <button
                                type="button"
                                className={`lh-filter-group-toggle ${isOpen ? "is-open" : ""} ${
                                    activeCategory === category.slug && !activeTopic ? "is-active" : ""
                                }`}
                                onClick={() => toggleCategory(category.slug)}
                                aria-expanded={isOpen}
                            >
                                <span>{category.name}</span>
                                <span className="lh-filter-chevron" aria-hidden="true">
                                    ▼
                                </span>
                            </button>
                            {isOpen && (
                                <div className="lh-filter-group-body">
                                    <button
                                        type="button"
                                        className={`lh-filter-topic ${
                                            activeCategory === category.slug && !activeTopic
                                                ? "is-selected"
                                                : ""
                                        }`}
                                        onClick={() => onSelectCategory(category.slug)}
                                    >
                                        All in this category
                                    </button>
                                    {topics.map((topic) => (
                                        <button
                                            key={topic.slug}
                                            type="button"
                                            className={`lh-filter-topic ${
                                                activeTopic === topic.slug ? "is-selected" : ""
                                            }`}
                                            onClick={() =>
                                                onSelectTopic(category.slug, topic.slug)
                                            }
                                        >
                                            {topic.name}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </>
    );

    return (
        <>
            <aside className="lh-sidebar lh-sidebar-desktop" aria-label="Article filters">
                {filterPanel}
            </aside>
            <div className="lh-sidebar-mobile">
                <button
                    type="button"
                    className="lh-mobile-filter-toggle"
                    onClick={onToggleMobile}
                    aria-expanded={mobileOpen}
                >
                    {mobileOpen ? "Hide filters" : "Show category filters"}
                </button>
                {mobileOpen && (
                    <aside className="lh-sidebar lh-sidebar-panel" aria-label="Article filters">
                        {filterPanel}
                    </aside>
                )}
            </div>
        </>
    );
}
